import { createReducer } from '@reduxjs/toolkit';
import {
  disableAccredibleSettings,
  disableOrgLevelCredlySettings,
  enableAccredibleSettings,
  enableCredlyBadgeTemplateId,
  getAccredibleGroup,
  removeAccredibleFromCourse,
  removeCredlyBadgeTemplateId,
  saveOrgLevelCredlySettings,
  updateAccredibleGroupId,
  validateAndSaveAccredibleGroupId,
} from 'redux/actions/digital-credential';
import { FullCourse } from 'redux/schemas/models/courseFull';
import { CredlySettingsPayload } from 'redux/schemas/models/credly';
import { getCurrentCourse } from 'redux/selectors/course';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { initialRootState } from './index';

export const getCredlySettings = (payload: CredlySettingsPayload) => {
  const { isCredlyEnable, credlyConfig: { organizationId, organizationToken } } = payload.institutionList;

  return {
    isActive: String(isCredlyEnable).toLowerCase() === 'true',
    organizationId,
    organizationToken,
  };
};

export default createReducer(initialRootState, builder => {
  builder.addCase(enableAccredibleSettings.fulfilled, (state, action) => {
    const currentInstitution = getCurrentInstitution(state);

    Object.assign(currentInstitution, action.payload.institutionList);
  });

  builder.addCase(disableAccredibleSettings.fulfilled, (state, action) => {
    const currentInstitution = getCurrentInstitution(state);

    Object.assign(currentInstitution, action.payload.institutionList);
  });

  builder.addCase(saveOrgLevelCredlySettings.fulfilled, (state, action) => {
    const currentInstitution = getCurrentInstitution(state);

    Object.assign(currentInstitution, action.payload.institutionList);
  });

  builder.addCase(disableOrgLevelCredlySettings.fulfilled, (state, action) => {
    const currentInstitution = getCurrentInstitution(state);

    Object.assign(currentInstitution, action.payload.institutionList);
  });

  builder.addCase(enableCredlyBadgeTemplateId.fulfilled, (state, action) => {
    const currentCourse: FullCourse = getCurrentCourse(state);

    currentCourse.credlyBadgeInfo = {
      id: '',
      name: '',
      description: '',
      url: '',
      imageUrl: '',
      state: 'draft',
    };

    Object.assign(currentCourse.credlyBadgeInfo, action.payload?.courseList?.credlyBadgeInfo);
  });

  builder.addCase(removeCredlyBadgeTemplateId.fulfilled, (state, action) => {
    const currentCourse: FullCourse = getCurrentCourse(state);

    currentCourse.credlyBadgeInfo = {
      id: '',
      name: '',
      description: '',
      url: '',
      imageUrl: '',
      state: 'draft',
    };

    Object.assign(currentCourse.credlyBadgeInfo, action.payload?.courseList?.credlyBadgeInfo);
  });

  builder.addCase(validateAndSaveAccredibleGroupId.fulfilled, (state, action) => {
    const currentCourse: FullCourse = getCurrentCourse(state);
    currentCourse.accredibleGroupId = action.meta.arg.groupId;
    // Guard against backend returns course data instead of group data
    // TODO: can be removed this once backend updates data
    if (Number(action.meta.arg.groupId) === Number(action.payload.id)) {
      currentCourse.accredibleGroupInfo = action.payload;
    } else {
      currentCourse.accredibleGroupInfo = null;
    }
  });

  builder.addCase(updateAccredibleGroupId.fulfilled, (state, action) => {
    const currentCourse: FullCourse = getCurrentCourse(state);
    currentCourse.accredibleGroupId = action.meta.arg.groupId;
    if (Number(action.meta.arg.groupId) === Number(action.payload.id)) {
      currentCourse.accredibleGroupInfo = action.payload;
    } else {
      currentCourse.accredibleGroupInfo = null;
    }
  });

  builder.addCase(removeAccredibleFromCourse.fulfilled, (state) => {
    const currentCourse: FullCourse = getCurrentCourse(state);
    currentCourse.accredibleGroupId = null;
    currentCourse.accredibleGroupInfo = null;
  });

  builder.addCase(getAccredibleGroup.fulfilled, (state, action) => {
    const currentCourse: FullCourse = getCurrentCourse(state);
    // Only update if course already has this groupId saved (not during validation-only calls)
    if (currentCourse?.accredibleGroupId
        && Number(currentCourse.accredibleGroupId) === Number(action.meta.arg.groupId)
    ) {
      currentCourse.accredibleGroupInfo = action.payload;
    }
  });
});
